import { BaseError } from '@dynamic-labs-sdk/client';

type UTXOsFetchErrorParams = {
  address: string;
  response: Response;
};

export class UTXOsFetchError extends BaseError {
  public readonly address: string;

  public readonly response: Response;

  constructor({ address, response }: UTXOsFetchErrorParams) {
    super({
      cause: null,
      code: 'utxos_fetch_error',
      details: `Address: ${address}, Status: ${response.status} ${response.statusText}`,
      docsUrl: null,
      name: 'UTXOsFetchError',
      shortMessage: 'Failed to fetch UTXOs from mempool',
    });

    this.address = address;

    this.response = response;
  }
}
